import {endpoint} from '~/api';
import {IPaginator} from '~/lib/paginator';
import {AdType, ICreative} from '~/modules/Creatives/models/Creative';
import {ITopCreativesFilter} from '~/modules/Creatives/models/filters';

export interface ICreativePaginator {
    pageNo?: number;
    pageSize?: number;
}

export interface ICreativeFilter {
    cid?: string;
    crid?: string;
    adDomain?: string;
    agencyId?: string;
    adCategory?: AdType;
}

const setUrlParam = <T extends any>(params: URLSearchParams, obj: T, field: keyof T, ) => {
    if (obj[field]) {
        params.set(field.toString(), obj[field].toString());
    }
};

export const fetchCreatives = (filter: ICreativeFilter, paginator: ICreativePaginator) => {
    const params = new URLSearchParams();
    setUrlParam<ICreativePaginator>(params, paginator, 'pageNo');
    setUrlParam<ICreativePaginator>(params, paginator, 'pageSize');

    setUrlParam<ICreativeFilter>(params, filter, 'cid');
    setUrlParam<ICreativeFilter>(params, filter, 'crid');
    setUrlParam<ICreativeFilter>(params, filter, 'adDomain');
    setUrlParam<ICreativeFilter>(params, filter, 'adCategory');
    setUrlParam<ICreativeFilter>(params, filter, 'agencyId');

    return endpoint.get<IPaginator<ICreative>>(`/creative?${params.toString()}`).then(r => r.data);
};

export const fetchTopCreatives = (filter: ITopCreativesFilter, sellerId: string) => {
    const params = new URLSearchParams();

    setUrlParam<ITopCreativesFilter>(params, filter, 'adDomain');
    setUrlParam<ITopCreativesFilter>(params, filter, 'adCategory');
    setUrlParam<ITopCreativesFilter>(params, filter, 'bundle');
    filter.categories.map(v => params.append('categories', v));
    params.set('period', filter.period.toString());
    params.set('sortBy', filter.sortBy.toString());

    return endpoint.get<ICreative[]>(`/creative/${sellerId}/top?${params.toString()}`).then(r => r.data);
};
